import { IFilter } from '../Tools/IFilter';
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from '../Tools/FiltersController';


export class ShowNewObjectsFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    nbColums?: number;
    controller: FiltersController;
    parentGroup: FilterGroup;
    isFirst: boolean;
    isLast: boolean;

    constructor(parentGroup: FilterGroup, isFirst: boolean, isLast: boolean, nbColumns: number) {
        this.id = 'showNewObjects';
        this.name = 'Nouveautés';
        this.type = 'showNewObjects';
        this.isFirst = isFirst;
        this.isLast = isLast;
        this.nbColums = nbColumns;
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = '';
        
        if (this.isFirst) {
            html += '<div class="noPadding" style="display: flex;flex-direction: row; justify-content: space-around;" id="showFilters">'
        }
        html += `
        <div class="${FilterGroup.getColumParam(this.nbColums!)}" style="width: fit-content;height: fit-content;">
            <input id="newObjectCheckbox" class="btn-default" type="checkbox">
            ${this.name}
        </div>
        `;
        if (this.isLast) {
            html += '</div>';
        }
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            $('#newObjectCheckbox').prop('checked', FilterGroup.filters.showNewObjects);
            this.controller.addEventListener('change', () => {
                let val = $('#newObjectCheckbox').is(':checked');
                FilterGroup.filters.showNewObjects = val;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'newObjectCheckbox');
        });
        return html;
    }

    // Done
    generateStringFilter(): string {
        if (!FilterGroup.smartSearch()) {
            if (FilterGroup.filters.showNewObjects === true) {
                let now = new Date();
                now.setMonth(now.getMonth() - 1);
                return('&q.pipeline.validationDate.gt=' + now.toISOString());
            }
        }
        return("");
    }

    destroy(): void {
        this.controller.destroy();
    }
}